import React, { memo } from 'react';
import styled from 'styles/styled-components';
import translations from 'translations';
import messages from './messages';

type ConfidenceLevel = 'high' | 'medium' | 'low' | 'none';

interface AccurateBadgeProps {
  level: string;
}

const COLOR_MAP: Record<ConfidenceLevel, { bg: string; text: string }> = {
  high: { bg: '#E6F9E7', text: '#43A047' },
  medium: { bg: '#F0F6FE', text: '#0D66F5' },
  low: { bg: '#FFF0E5', text: '#E56910' },
  none: { bg: '#FEF2F2', text: '#E2483C' },
};

const LABEL_MAP: Record<ConfidenceLevel, keyof typeof messages> = {
  high: 'confidenceHigh',
  medium: 'confidenceMedium',
  low: 'confidenceLow',
  none: 'confidenceNone',
};

const Badge = styled.span<{ bg: string; color: string }>`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 6px;
  border-radius: 80px;
  background: ${({ bg }) => bg};
  color: ${({ color }) => color};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  gap: 2px;
`;

const AccurateBadge = ({ level }: AccurateBadgeProps) => {
  const key = (level?.toLowerCase() ?? 'none') as ConfidenceLevel;
  const colors = COLOR_MAP[key] ?? COLOR_MAP.none;
  const labelKey = LABEL_MAP[key] ?? LABEL_MAP.none;
  return (
    <Badge bg={colors.bg} color={colors.text}>
      {translations(messages[labelKey])}
    </Badge>
  );
};

export default memo(AccurateBadge);
